document.addEventListener('DOMContentLoaded', () => {
  const updateRewardBar = () => {
    fetch(window.location.href)
      .then(response => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const updatedBars = doc.querySelectorAll('[data-rewards-bar]');
        const currentBars = document.querySelectorAll('[data-rewards-bar]');
        updatedBars.forEach((newBar, i) => {
          if (currentBars[i]) {
            currentBars[i].innerHTML = newBar.innerHTML;
          }
        });

        // ✅ Gère l'animation "pulse" unique juste après mise à jour
        const justUnlocked = document.querySelectorAll('.tier.just-unlocked');
        justUnlocked.forEach((el) => {
          el.classList.add('pulsing');
          setTimeout(() => {
            el.classList.remove('just-unlocked');
            el.classList.remove('pulsing');
          }, 900);
        });
      });
  };

  const cartElement = document.querySelector('[data-cart-container]') || document.querySelector('form[action="/cart"]');
  const drawer = document.querySelector('cart-drawer');

  const observer = new MutationObserver(() => {
    updateRewardBar();
  });

  if (cartElement) {
    observer.observe(cartElement, { childList: true, subtree: true });
  }

  if (drawer) {
    observer.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('change', (e) => {
    if (e.target.name === 'updates[]') {
      setTimeout(updateRewardBar, 500);
    }
  });
});
